import { render, staticRenderFns } from "./BankFooter.vue?vue&type=template&id=c7d06206&scoped=true"
import script from "./BankFooter.vue?vue&type=script&lang=js"
export * from "./BankFooter.vue?vue&type=script&lang=js"
import style0 from "./BankFooter.vue?vue&type=style&index=0&id=c7d06206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d06206",
  null
  
)

export default component.exports